import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSiteOrigin, upsertMeta, updateSocialMetadata } from '../lib/seoMetadata';

const pageMetadata = {
  '/': {
    title: 'The Wisdom Network | Verified Wisdom, Powerful Transformations',
    description:
      'Book private sessions with verified spiritual and holistic practitioners, or explore guided experiences and memberships from The Wisdom Network.',
  },
  '/practitioners': {
    title: 'Meet Our Practitioners | The Wisdom Network',
    description:
      'Browse verified spiritual life coaches, healers, psychic readers, astrologers, and holistic practitioners.',
  },
  '/soul-journey': {
    title: 'Soul Journey | The Wisdom Network',
    description:
      "Explore The Wisdom Network's Sacred Soul Journey, a six-week private one-to-one experience.",
  },
  '/experiences': {
    title: 'Guided Experiences | The Wisdom Network',
    description:
      'Explore live and guided experiences from The Wisdom Network, including The Sovereign Choice with Goddess Iman.',
  },
  '/membership': {
    title: 'Memberships | The Wisdom Network',
    description: 'Membership information from The Wisdom Network.',
  },
  '/reviews': {
    title: 'Community Reviews | The Wisdom Network',
    description:
      'Read approved reflections from people who found care, clarity, and connection in The Wisdom Network community.',
  },
  '/how-it-works': {
    title: 'How It Works | The Wisdom Network',
    description: 'Learn how to find a practitioner and book a session through The Wisdom Network.',
  },
  '/about': {
    title: 'About The Wisdom Network',
    description: 'Learn about The Wisdom Network and our approach to verified spiritual guidance.',
  },
  '/faq': {
    title: 'Frequently Asked Questions | The Wisdom Network',
    description: 'Find answers about The Wisdom Network, practitioners, sessions, and support.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | The Wisdom Network',
    description: 'Read The Wisdom Network privacy policy and learn how CMBC Wellness LLC handles information.',
  },
  '/terms-conditions': {
    title: 'Terms & Conditions | The Wisdom Network',
    description: 'Read the terms and conditions for using The Wisdom Network website and services.',
  },
  '/contact': {
    title: 'CONTACT US | The Wisdom Network',
    description: 'Contact The Wisdom Network for assistance with practitioners, sessions, and support.',
  },
  '/mcm': {
    title: 'MYSTIC CIRCLE MAGAZINE | The Wisdom Network',
    description:
      'Explore Mystic Circle Magazine, a publication sharing mystical teachings, practitioner wisdom, and soul-deep guidance.',
    indexable: false,
  },
  '/cindie-ongoing-support': {
    title: "Cindie's Ongoing Spiritual Support | The Wisdom Network",
    description:
      'Explore spiritual life coaching, personal manifestation, and aligned CEO coaching with Cindie Phanhmixay.',
    indexable: false,
  },
  '/aquiera-ongoing-support': {
    title: "Aquiera's Ongoing Spiritual Support | The Wisdom Network",
    description:
      'Explore worthiness coaching, intuition, spiritual life coaching, and hypnosis offerings with Aquiera Halsey, MPH.',
    indexable: false,
  },
  '/frequency-boost': {
    title: 'Frequency Boost | The Wisdom Network',
    description:
      'The Peace Frequency Reboot with Goddess Iman: a private one-hour session focused on nervous system recalibration and energetic support.',
  },
  '/mahalia': {
    title: 'Mahalia Thomas | The Wisdom Network',
    description:
      'Meet Mahalia Thomas, a verified spiritual life coach supporting empaths through energetic protection, chakra alignment, and spiritual coaching.',
  },
  '/audrina': {
    title: 'Audrina Divine | The Wisdom Network',
    description:
      'Meet Audrina Divine, a spiritual life coach and clinical hypnotist supporting women to heal from survival mode through whole-body, nervous system, and subconscious work.',
  },
  '/karnada': {
    title: 'Karnada Lewis | The Wisdom Network',
    description:
      'Meet Karnada Lewis, the Matriarch Mystic: a spiritual guide with over 20 years of experience and dedicated support for single parents and caregivers.',
  },
  '/micki': {
    title: 'Micki Mathis | The Wisdom Network',
    description:
      'Meet Micki Mathis, The Trauma Sniper: a spiritual life coach offering trauma energy healing, astrology, natal chart readings, and energy protection.',
  },
  '/sovereignty-amplified': {
    title: 'Sovereignty Amplified | The Wisdom Network',
    description:
      "Explore Goddess Iman's six-week private intensive for nervous system mastery, boundaries, discernment, emotional sovereignty, and ongoing support.",
  },
  '/after-the-reset': {
    title: 'After The Reset | The Wisdom Network',
    description:
      'Continue your Reset Room experience with a $150 one-on-one hypnosis consultation with Audrina Divine and a custom program designed around you.',
  },
  '/detach-protocol': {
    title: 'The Detach Protocol | The Wisdom Network',
    description:
      'A 30-day no-contact deep rewire with Dannielle Holmes, including weekly consultations, hypnosis sessions, daily journal prompts, and on-demand support.',
  },
  '/audrina-ongoing-support': {
    title: "Audrina's Ongoing Spiritual Support | The Wisdom Network",
    description:
      "Explore Audrina Divine's ongoing support packages: Burn & Bloom, Soul Sync, Rooted & Radiant, Embodying the Fire, and Spiritual Life Coaching.",
    indexable: false,
  },
  '/podcast': {
    title: 'Podcast | The Wisdom Network',
    description:
      'Listen to Reality Rewire, The Wisdom Network podcast exploring hypnotherapy, energy healing, and spiritual life coaching.',
  },
  '/aquiera': {
    title: 'Aquiera Halsey, MPH | The Wisdom Network',
    description:
      'Meet Aquiera Halsey, MPH, a worthiness coach, psychic, and hypnotist helping women return to self-trust, abundance, and inner freedom.',
  },
  '/ebony': {
    title: 'Ebony Goodrich, Past Life Pilot | The Wisdom Network',
    description:
      'Meet Ebony Goodrich, The Past Life Pilot, and explore past-life regression and hypnotherapy for patterns that feel difficult to explain.',
  },
  '/dannielle': {
    title: 'Dannielle Holmes | The Wisdom Network',
    description:
      'Meet Dannielle Holmes, a certified hypnotist, spiritual life guide, and multi-dimensional healer helping women heal, grow, and glow.',
  },
  '/reclaim': {
    title: 'Reclaiming the Lost Self | The Wisdom Network',
    description:
      'A 91-minute Soul Activation Series experience with six master healers to help you release old programming and reconnect with yourself.',
    indexable: false,
  },
  '/clarify': {
    title: "Clarifying Your Soul's GPS | The Wisdom Network",
    description:
      'A Soul Activation Series experience focused on soul-level clarity, intuition, personal power, and direction.',
    indexable: false,
  },
  '/rise': {
    title: 'Awaken and Rise | The Wisdom Network',
    description:
      'A Soul Activation Series ceremony with four experiences designed to connect you with your future self, ancestors, and personal power.',
    indexable: false,
  },
  '/reset-room': {
    title: 'The Reset Room | The Wisdom Network',
    description:
      'A two-hour virtual healing intensive combining nervous system education, gentle movement, and guided hypnotherapy.',
    indexable: false,
  },
  '/goddessiman-ongoing-support': {
    title: "GoddessIman's Ongoing Support | The Wisdom Network",
    description:
      'Explore GoddessIman’s ongoing coaching and somatic support packages for self-love, sovereignty, spiritual power, and purpose.',
  },
  '/gordon': {
    title: 'Gordon Allen, Spiritual Bio-Hacking Coach | The Wisdom Network',
    description:
      'Meet Gordon Allen, a spiritual bio-hacking coach helping men work through past trauma, emotional burnout, and life on autopilot.',
  },
  '/goddessiman': {
    title: 'GoddessIman | The Wisdom Network',
    description:
      'Meet GoddessIman, a liberation and ascension guide supporting people through identity change, old patterns, and becoming who they are next.',
  },
};

const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = pageMetadata[pathname] || pageMetadata['/'];
    const isPractitionerProfile = /^\/practitioners\/[^/]+$/.test(pathname);
    const isLandingPage = /^\/offers\/[^/]+$/.test(pathname);
    const isIndexableMetadataPage =
      Boolean(pageMetadata[pathname]) && pageMetadata[pathname].indexable !== false;
    const indexable =
      (isIndexableMetadataPage || isPractitionerProfile || isLandingPage) &&
      pathname !== '/membership';
    const canonicalPath = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
    const canonicalUrl = `${getSiteOrigin()}${canonicalPath}`;

    document.title = metadata.title;
    upsertMeta('meta[name="description"]', { name: 'description' }, metadata.description);
    upsertMeta(
      'meta[name="robots"]',
      { name: 'robots' },
      indexable ? 'index, follow, max-image-preview:large' : 'noindex, follow',
    );
    upsertMeta(
      'meta[name="googlebot"]',
      { name: 'googlebot' },
      indexable ? 'index, follow, max-image-preview:large' : 'noindex, follow',
    );
    updateSocialMetadata({
      title: metadata.title,
      description: metadata.description,
      url: canonicalUrl,
      type: isPractitionerProfile ? 'profile' : 'website',
    });

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);
  }, [pathname]);

  return null;
};

export default Seo;